<template>
  <div class="weather-pie">
    <ul>
      <li class="pieChart" :data-percent="percent" :id="pieName">
        <span>{{ percent }}</span
        >%
      </li>
    </ul>
  </div>
</template>

<script>
import "@/lib/pieChart.js";

export default {
  props: ["percent", "pieName"],
  mounted() {
    var options = {
      scaleColor: false,
      trackColor: "#CCCCCC",
      barColor: "#FDAB57",
      lineWidth: 20,
      lineCap: "butt",
      size: 220,
    };
    const el = document.getElementById(this.pieName);
    var chart = new window.EasyPieChart(el, options);
    chart.update(this.percent);
  },
  methods: {
  },
};
</script>
<style lang="scss">
.weather-pie {
  ul {
    margin: 0;
    padding: 0;
  }
  .pieChart {
    display: block;
    width: 200px; // 180
    height: 220px; // 220
    margin: 10px auto 0;
    position: relative;
    box-sizing: border-box;
    // padding-top: 100px;
    padding-top: 120px;
    text-align: center;
    color: #fdab57;
    font-size: 20px;

    .mobile & {
      width: 180px;
    }
  }
  .pieChart span {
    display: block;
    font-size: 56px;
    font-weight: 500;
    color: #fdab57;
    position: absolute;
    // top: 60%;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);

    .mobile & {
      font-size: 50px;
    }
  }
  .pieChart canvas {
    position: absolute;
    // top: 65%;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -55%);
  }
}
</style>